module.exports = __webpack_public_path__ + "img/move19.84903ae4.jpg";